var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('bot-service-metadata-list-card',{staticClass:"flex-shrink-0",attrs:{"hide-search":"","header":"Data Sources","bot":_vm.bot,"items":_vm.dataSourcesMetadata}})
}
var staticRenderFns = []

export { render, staticRenderFns }